import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faGlobe } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { isoToFlag } from "../util";
import AddLanguagePopup from "./AddLanguagePopup";
import { useLanguage } from "../context/LanguageContext";
import { usePermission } from "../context/PermissionContext";

const Languages = ({ projectId }) => {
  const [showForm, setShowForm] = React.useState(false);
  const { languages, displayLanguages, toggleDisplayLanguage } = useLanguage();
  const { hasAdminRight } = usePermission();

  const visibleCount = (displayLanguages ?? []).length;
  const totalCount = languages.length;

  const toggleAll = () => {
    const shouldShowAll = visibleCount < totalCount;
    languages.forEach((lang) => {
      const isVisible = displayLanguages?.includes(lang.id);
      if (shouldShowAll && !isVisible) toggleDisplayLanguage(lang.id);
      if (!shouldShowAll && isVisible) toggleDisplayLanguage(lang.id);
    });
  };

  return (
    <>
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-3 mb-4 flex flex-wrap items-center gap-2">
        <span className="text-xs uppercase tracking-wide text-gray-400 font-semibold flex items-center gap-1.5 mr-1">
          <FontAwesomeIcon icon={faGlobe} className="w-3 h-3" />
          Languages
          <span className="text-gray-400 normal-case tracking-normal font-normal">
            ({visibleCount}/{totalCount})
          </span>
        </span>
        {languages.map((language) => {
          const isVisible =
            !displayLanguages || displayLanguages.includes(language.id);
          return (
            <button
              type="button"
              key={language.id}
              onClick={() => toggleDisplayLanguage(language.id)}
              title={language.name}
              className={classNames(
                "inline-flex items-center gap-1.5 h-8 px-3 rounded-full border text-xs font-medium transition",
                isVisible
                  ? "bg-primary bg-opacity-10 text-gray-800 border-primary"
                  : "bg-white text-gray-400 border-gray-200 hover:border-gray-300"
              )}
            >
              <span className="text-base leading-none">
                {isoToFlag(language.iso)}
              </span>
              <span className="uppercase tracking-wide">{language.iso}</span>
            </button>
          );
        })}
        {totalCount > 0 && (
          <button
            type="button"
            onClick={toggleAll}
            className="ml-1 text-xs text-gray-500 hover:text-gray-800 underline"
          >
            {visibleCount < totalCount ? "Show all" : "Hide all"}
          </button>
        )}
        {hasAdminRight && (
          <button
            type="button"
            title="Add language"
            aria-label="Add language"
            className="ml-auto inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-white bg-primary text-xs font-semibold shadow-sm hover:opacity-95 transition"
            onClick={() => setShowForm(true)}
          >
            <FontAwesomeIcon icon={faPlus} className="w-3 h-3" />
            Add language
          </button>
        )}
      </div>
      {showForm && (
        <AddLanguagePopup
          projectId={projectId}
          onClose={() => setShowForm(false)}
        />
      )}
    </>
  );
};
export default Languages;
